module.exports = __webpack_public_path__ + "static/img/text_icon1.a50057c9.png";